<ds-modal
  #modelPricingModal
  [dimensionsConfig]="{ width: '900px' }"
  [ds-modal-trigger-for]="modelPricingModal"
  [(isModalOpen)]="modelPricingModalIsOpen"
  [detachFooter]="true"
  style="font-family: 'BMWTypeNext', sans-serif"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    BMW PRICING
  </ds-box-header>
  <ds-box-content>
    <div class="info-section">
      <div class="info-column">
        <div class="info-item">
          Pricing Date:<strong> {{ pricePerBodyResponse?.pricedate }}</strong>
        </div>
      </div>
      <div class="info-column">
        <div class="info-item">
          Engine Number:<strong> {{ pricePerBodyResponse?.engineno }}</strong>
        </div>
      </div>
    </div>
    <div class="table-section">
      <div class="table-scroll-container">
        <table class="ds-table zebra-table fixed-header-table">
          <thead>
          <tr class="table_head">
            <th *ngFor="let column of columnData">{{ column.headerName }}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of rowsData">
            <td *ngFor="let column of columnData">
              {{ row[column.field] }}
            </td>
          </tr>
          </tbody>

        </table>
      </div>
    </div>

    <div class="summary-section">
      <table class="ds-table summary-table" style="width: 90%;">
        <tbody>
          <tr>
            <td style="text-align: right; width: 50%;"><strong>{{ pricePerBodyResponse?.vatlabel }}</strong></td>
            <td style="text-align: right; width: 15%;"><strong>{{ pricePerBodyResponse?.vatamount }}</strong></td>
            <td style="width: 5%;"></td>
          </tr>
          <tr>
            <td style="text-align: right;"><strong>{{ pricePerBodyResponse?.co2label }}</strong></td>

            <td style="text-align: right;"><strong>{{ pricePerBodyResponse?.co2amount }}</strong></td>
          </tr>
          <tr>
            <td style="text-align: right;"><strong>{{ pricePerBodyResponse?.totallabel }}</strong></td>

            <td style="text-align: right;"><strong>{{ pricePerBodyResponse?.total }}</strong></td>
            <td style="text-align: right;width: 10%"><strong>{{ pricePerBodyResponse?.totalretail }}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>


  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      variant="primary"
      (click)="closeModal()"
    >
      Close
    </button>
  </ds-box-footer>
</ds-modal>